import $ from 'jquery';
import axios from 'axios';
import { render } from './render';
import { tutorUrl } from '../routes';

const abortControllerErrorName = 'CanceledError';
const pageField = 'LessonListSearchForm[page]';
const tutorRestUrl = '/rest/tutor/index';

let abortController = null;

const showSpinner = () => { /* ждем дизайна */ }

const hideSpinner = () => { /* ждем дизайна */ }

export const search = async function (page = 1) {
    if (abortController) {
        abortController.abort();
    }

    abortController = new AbortController();
    showSpinner();

    try {
        const formData = $('#tutor-search-form').serialize();

        console.log(formData)

        const response = await axios.get(`${tutorRestUrl}?${formData}&${encodeURI(pageField)}=${page}`, {
            params: {},
            signal: abortController.signal,
        });

        window.history.pushState({}, '', `${tutorUrl}?${formData}`);

        render(response.data);
    } catch (error) {
        if (error.name !== abortControllerErrorName) {
            throw error;
        }
    } finally {
        hideSpinner();
    }
}
